import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import WeekDaysCards from "../weekdayscards/weekdayscards.component";
import TimeRangeSlider from 'react-time-range-slider';
import ModalSelectHours from "../../../FO/components/modalselecthours/modalselecthours.component";
import moment from "moment";
import {isEmpty} from "../../helpers/general.helper";
import HallMap from "../hallmap/hallmap.component";
import ReservationStep2 from "./reservationstep2.component";

class ModalReservation extends Component {

    constructor(props) {
        super(props);

        this.state = {
            value: {
                start: "00:30",
                end: "23:59",
                nextStep: false
            },
            movieSchedule: []
        };
    }

    componentWillReceiveProps(nextProps){
        if(this.props.movieSchedule !== nextProps.movieSchedule){
            this.setState({movieSchedule: nextProps.movieSchedule})
        }
    }

    processChange = (value) => {
        this.setState({
            value:value
        })
        let hours = [];
        this.props.movieSchedule.map((item,i) => {
             let filtredHours = item.schedule_broadcast_hours.filter((hour) => {
                 let movieScheduleHour = moment(this.props.reservationDate + " " + hour.schedule_broadcast_hour).unix();
                 let hourStart = moment(this.props.reservationDate + " " + value.start).unix();
                 let hourEnd = moment(this.props.reservationDate + " " + value.end).unix();
                 return movieScheduleHour >= hourStart && movieScheduleHour <= hourEnd
             });
             const newItem = Object.assign({}, item);
             newItem.schedule_broadcast_hours = filtredHours; 
             hours.push(newItem);
             return null;
        })
        this.setState({movieSchedule: hours});
    };

    handleNextStep = () => {
        this.setState({nextStep: !this.state.nextStep});
    }

    getScheduleTime = () => {
        return {
            day: moment(this.props.reservationDate).locale('ro').format("dddd"),
            selectedHour: this.props.selectedHour.hour,
            selectedDate: moment(this.props.reservationDate).format("DD.MM.YYYY"),
            projectionFormat: this.props.selectedHour.projectionFormat
        }
    }

    render() {
        return (
            <Modal size={'lg'} isOpen={this.props.openModal} toggle={this.props.toggle} backdrop={false} fade={false} className={this.props.className}>
                <ModalHeader toggle={this.props.toggle}></ModalHeader>
                <ModalBody>
                    { !this.props.nextStep ?
                    <div className="row">
                       {/* <div className="col-lg-3 modal-left">
                            <div className="row">
                                <span>Cinematografe in </span>
                            </div>
                            <div className="row">
                                <select className="select-city">
                                    <option value="volvo">Brasov</option>
                                    <option value="saab">Bucuresti</option>
                                    <option value="mercedes">Alba Iulia</option>
                                    <option value="audi">Cluj Napoca</option>
                                </select>
                            </div>
                        </div>*/}
                        <div className="col-lg-12 modal-right">
                            <div className="modal-right-header">
                            
                                <span className="modal-movie-title">{this.props.movie.film_translated_title}</span><br/>
                                <span className="modal-translated">{this.props.movie.film_title}</span>
                                <hr />
                            </div>
                            <div className="row">
                                <div className="col-lg-6 modal-left-filters">
                                    <span className="modal-choose-txt">ALEGE ZIUA</span>
                                    <div className="col-lg-12">
                                        <div className="row">
                                            <WeekDaysCards />
                                            <div className="margin-left-right-5">
                                                <hr/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="row">
                                            <div className="modal-hours-selection margin-left-right-5">
                                                <span className="partial-border choose-hour">ALEGE INTERVALUL ORAR</span>
                                                <div className="modal-range-slider">
                                                    <TimeRangeSlider
                                                        value={this.state.value}
                                                        onChange={(value) => this.processChange(value)}
                                                    />
                                                    <span className="interval-show">Între { this.state.value.start } - { this.state.value.end }</span>
                                                </div>
                                            </div>
                                            <div className="margin-left-right-5">
                                                <hr/>
                                                <span className="choose-hour">ALEGE ORA</span>
                                                <ModalSelectHours movieSchedule={this.state.movieSchedule} schedule={this.props.schedule}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    {
                                        isEmpty(this.props.hallConfiguration) ?
                                        <Fragment>
                                            <p className="text-center">Vă rugăm să selectaţi o ora</p>
                                        </Fragment> :
                                        <Fragment>
                                            <span className="modal-choose-txt">ALEGE LOCUL</span>
                                            <div className="screen">
                                                <br/>
                                                <span className="modal-choose-txt">Ecran { this.props.hallConfiguration.room.name }</span>
                                            </div>
                                            <HallMap />                                     
                                            {this.props.selectedSeats.length > 0 || this.props.selectedCouch.length > 0 ? <button className="order-step" onClick={this.props.processNexStep}>Pasul următor</button> : ""}
                                        </Fragment>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    : <ReservationStep2 scheduleTime={this.getScheduleTime()} />}
                </ModalBody>
            </Modal>
        );
    }
}

const mapStateToProps = state => ({
    hallConfiguration: state.movieTheaters.hallConfiguration,
    movie: state.movies.movieDetails,
    reservationDate: state.filters.reservetionSelectedDate,
    selectedSeats: state.movieTheaters.selectedSeats,
    selectedCouch: state.movieTheaters.selectedCouch,
    selectedHour: state.filters.movieDetailsFilters,
});
export default connect(mapStateToProps, {})(ModalReservation);






// WEBPACK FOOTER //
// ./src/SHARED/components/modalreservation/modalreservation.component.js